import React, { PureComponent, Suspense } from "react";
import { Consume } from "../Context/Consumer";
import {
  WebConfigDataContext,
  ConstraintsContext,
  TransContext,
  LoginContext,
} from "../Context";
import config from "../common/config";
import myConfigRoutes from "../common/routeConfig";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import NoMatch from "./noMatch";
import { getLoginCookie, getParams, getTrans, googleAnalyticsTracking, setLocation } from "../common";
import _ from "lodash";
const doDefaultNavigation = (DefaultComponent, path, routeObject, props) => {
  //end

  // if (routeObject.path == "*") {
  //   return (<Redirect replace to={(config.BASE_DOMAIN + '/create-team')} />);
  // }
  console.log("hey there");
  let sTitle = "";

  document.title = getTrans(props.TransData.data,"menu_"+routeObject.title,routeObject.title);

  sTitle = document.title;
  googleAnalyticsTracking(sTitle, routeObject?.path);
  
  let userProfile = getLoginCookie();

  const sSearch = getParams();
  if (!_.size(userProfile)) {
    setLocation(routeObject.path);
    if (routeObject.isAuthRequired) {
      return (
        <Redirect replace to={config.BASE_DOMAIN_LANG + "home" + sSearch} />
      );
    }
  } else {
    setLocation(routeObject.path);
    if (
      userProfile.HasTeam == 1 &&
      (routeObject.path === config.BASE_DOMAIN_LANG + "create-team" ||
        (!window.currentPage &&
          (routeObject.name === "manage-team" ||
            routeObject.name === "transfer-summary")))
    ) {
      return (
        <Redirect replace to={config.BASE_DOMAIN_LANG + "my-team" + sSearch} />
      );
    } else if (
      userProfile.HasTeam != 1 &&
      !window.currentPage &&
      (routeObject.name === "my-team" ||
        routeObject.name === "leagues" ||
        routeObject.name === "manage-team")
    ) {
      return (
        <Redirect
          replace
          to={config.BASE_DOMAIN_LANG + "create-team" + sSearch}
        />
      );
    }
  }

  const SomeComponent = withRouter((props) => {
    window.currentPage = routeObject.path;
    const Elem = DefaultComponent;
    return (
      <React.Fragment>
        <Elem {...props} />
      </React.Fragment>
    );
  });
  return <SomeComponent />;
};

class Routes extends PureComponent {
  render() {
    let loaderMarkUp = (
      <div>
        <div id="loaderWrap" className="si-loader__wrap si-center">
          <div className="si-loader"></div>
        </div>
      </div>
    );
    const myRoutes = myConfigRoutes.map((el, index) => {
      let component = el.component;
      let path = el.path;
      if (path === "/") {
        return (
          <Route
            exact
            key={index}
            path={path}
            render={() => doDefaultNavigation(component, path, el, this.props)}
          />
        );
      }
      return (
        <Route
          key={index}
          path={path}
          render={() => doDefaultNavigation(component, path, el, this.props)}
        />
      );
    });
    return (
      <Suspense fallback={loaderMarkUp}>
        <Switch>
          {myRoutes}
          <Route component={NoMatch} />
        </Switch>
      </Suspense>
    );
  }
}

export default withRouter(
  Consume(Routes, [
    WebConfigDataContext,
    ConstraintsContext,
    TransContext,
    LoginContext,
  ])
);
